import { Intro,PricePage,Fund } from ".";
export default {
  path: "",
  childRoutes: [
    { path: "", component: Intro, isIndex: true },
    { path: "price", component: PricePage, isIndex: false },
    { path: "fund", component: Fund, isIndex: false },
],
};
